import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function addFromTemplate({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ councilApplicationAddFromTemplateShow: true });
  setTimeout(() => {
    pageComponent.councilApplicationAddFromTemplate.current?.getCouncilApplicationTypeDataSource();
  }, config.setTimeoutMilliSecond);
}

//弹出mailmerge的div
export function docMergeCouncilApplication({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ mailMergeTemplateShow: true, mailMergeObjId: parameter.CouncilApplicationId, mailMergeObj: parameter, dataModelType: 8 });
  setTimeout(() => {
    pageComponent.mailMergeTemplate.current?.getMailMergeTemplate(8, parameter.CouncilApplicationId);
  }, config.setTimeoutMilliSecond);
}
